export const ERROR_REASON = {
    SIZE: 'ERROR_REASON_SIZE',
    EXCEEDED_FILES_SIZE: 'ERROR_REASON_EXCEEDED_FILES_SIZE',
    TYPE: 'ERROR_REASON_TYPE'
}